var map = {
	"./#03CEA4/image.svg": "1801",
	"./#3777FF/image.svg": "a5e6",
	"./#EE964B/image.svg": "85be",
	"./#F754A2/image.svg": "b9e1",
	"./#FF495C/image.svg": "8d0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e5d1";